import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/AuthUtils';
import SpocDeviceRegistrationGate from '../../components/Devices/SpocDeviceRegistrationGate';

const ProtectedRoute = ({ children }) => {
  const location = useLocation(); // To save the current path

  if (!isAuthenticated()) {
    // If not logged in, redirect to login with the original location saved
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // If logged in, allow access to the route. Mounted here rather than on
  // any one page so a SPOC can't dodge the device-registration requirement
  // by navigating away from the dashboard - see the gate's own comments.
  //
  // A non-SPOC employee with an unregistered device used to get an
  // equivalent full-screen blocking notice here (EmployeeDeviceNoticeGate),
  // but that blocked the whole app for something that only affects
  // clock-in - removed in favor of hiding just the Clock-In button itself,
  // with an inline message, on the dashboard and Attendance page (see
  // AttendanceDetails.jsx / AttendenceEmployee.jsx), so the rest of the app
  // stays usable.
  return (
    <>
      {children}
      <SpocDeviceRegistrationGate />
    </>
  );
};

export default ProtectedRoute;